const UpcomingVisits = ({ nextVisitServices, translationMap }) => {
  if (!nextVisitServices) return null;

  return (
    <div className="register_box4">
      <h6 className="Gray_Title">{translationMap?.nextSteps}</h6>
      {nextVisitServices.split(",").map((service, index) =>
      <p className="small_title_txt">{service}</p>
      )}
    </div>);

};

export default UpcomingVisits;